/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as ActivarRouteImport } from './routes/activar';
import { Route as PantallaRouteImport } from './routes/pantalla';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const ActivarRoute = ActivarRouteImport.update({
  id: '/activar',
  path: '/activar',
  getParentRoute: () => rootRouteImport,
} as any);
const PantallaRoute = PantallaRouteImport.update({
  id: '/pantalla',
  path: '/pantalla',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/activar': typeof ActivarRoute;
  '/pantalla': typeof PantallaRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/activar': typeof ActivarRoute;
  '/pantalla': typeof PantallaRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/activar': typeof ActivarRoute;
  '/pantalla': typeof PantallaRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths: '/' | '/activar' | '/pantalla';
  fileRoutesByTo: FileRoutesByTo;
  to: '/' | '/activar' | '/pantalla';
  id: '__root__' | '/' | '/activar' | '/pantalla';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ActivarRoute: typeof ActivarRoute;
  PantallaRoute: typeof PantallaRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/activar': {
      id: '/activar';
      path: '/activar';
      fullPath: '/activar';
      preLoaderRoute: typeof ActivarRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pantalla': {
      id: '/pantalla';
      path: '/pantalla';
      fullPath: '/pantalla';
      preLoaderRoute: typeof PantallaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivarRoute: ActivarRoute,
  PantallaRoute: PantallaRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
